import { type UseQueryResult, useQuery } from 'react-query';
import {
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto,
} from '../../services/wealthlane-award-services';
import { useSelector } from 'react-redux';
import { selectTenantId } from '../../pages/configuration/participantSignupSlice';
import { ParticipantTradePreClearanceService } from '../../services/wealthlane-award-services/services/ParticipantTradePreClearanceService';
import { isEmpty } from 'lodash';

const useGetParticipantTradePreClearances = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  isOnBoarded?: boolean,
  isEsppOnly?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_TradePreClearance_TradePreClearanceParticipantDto | undefined,
  unknown
> => {
  const tenantId = useSelector(selectTenantId);
  const participantTradePreClearances = useQuery(
    ['getParticipantTradePreClearances', isOnBoarded, tenantId],
    async () => {
      if (
        tenantId
        // removed due to logical issues, api called before session created
        // && isOnBoarded === true
      ) {
        return await handleRequest(
          ParticipantTradePreClearanceService.getApiAwardApiAppParticipantTradePreClearanceParticipantTradePreClearance()
        );
      }
    },
    {
      enabled: !isEsppOnly,
    }
  );

  return participantTradePreClearances;
};

export default useGetParticipantTradePreClearances;
